
import { useRouteMatch } from "react-router"

import { MDB_TYPES as TYPES } from "@meddbriefer/scenario-data/constants.js"

import { useScenario } from "../contexts/ScenarioContext"

import PhaseNav from "./PhaseNav"

const COLORS = [
 "#e5ba8eff",
 "#c0aac8ff",
 "#aad5d9ff",
 "#b9ba6aff",
 "#ebcd68ff",
 "#a5afd9ff",
 "#a5c4bbff",
 "#b9ba6aff"
]

const PhaseNavPane = () => {
    const { scenario } = useScenario()
    const { url } = useRouteMatch()

    return (
        <>
        {scenario.phaseData.filter(rec => rec.type === TYPES.PHASE).map((phase, index) => (
            <PhaseNav
                key={phase.id}
                baseURL={url}
                activeColor={COLORS[index]}
                id={phase.id}
                label={phase.label}
                subPhases={phase.subPhases}
            />
        ))}
        </>
    )

}

export default PhaseNavPane